export default __webpack_public_path__ + "static/media/decada-0080-0009-min.5485d18a.jpg";